import type { RouteRecordRaw } from 'vue-router';
import { familyRoutes } from './routes.family';

/**
 * Full PWA PRIVATE routes (Phase 2.2) — installed at runtime by the router guard when the authenticated
 * customer's ctype is FULL. Public/pre-auth routes live in routes.shared.ts. Each component is a lazy
 * import() so a vitrine session never downloads these chunks.
 */
export const fullPrivateRoutes: RouteRecordRaw[] = [
  { path: '/home',      name: 'home',      component: () => import('@/views/home/HomeView.vue') },
  { path: '/payments',  name: 'payments',  component: () => import('@/views/payments/PaymentsView.vue') },
  { path: '/history',   name: 'history',   component: () => import('@/views/history/HistoryView.vue') },
  { path: '/settings',  name: 'settings',  component: () => import('@/views/settings/SettingsView.vue') },
  { path: '/analytics', name: 'analytics', redirect: { name: 'history' } },

  { path: '/wallet', name: 'wallet', component: () => import('@/views/wallet/WalletView.vue') },
  { path: '/wallet/receive', name: 'wallet-receive', component: () => import('@/views/wallet/ReceiveView.vue') },
  { path: '/wallet/send', name: 'wallet-send', component: () => import('@/views/wallet/SendView.vue') },
  { path: '/wallet/pending', name: 'wallet-pending', component: () => import('@/views/wallet/PendingDepositsView.vue') },

  { path: '/kyc', name: 'kyc', component: () => import('@/views/kyc/KycView.vue') },
  { path: '/cards', name: 'cards', component: () => import('@/views/cards/CardListView.vue') },
  { path: '/cards/new', name: 'card-new', component: () => import('@/views/cards/NewCardView.vue') },
  { path: '/cards/issued/:cardId', name: 'card-issued', component: () => import('@/views/cards/CardIssuedView.vue') },
  { path: '/cards/:cardId', name: 'card-detail', component: () => import('@/views/cards/CardDetailView.vue') },
  { path: '/profile', name: 'profile', component: () => import('@/views/profile/ProfileView.vue') },

  // Family Office (read-only viewer + TSV export) — shared across products, see routes.family.ts (§4.8).
  ...familyRoutes,
];
